import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { manageUserActions } from "../../../../store/external/manage-user/manage-user.reducer";
import { TABLE_PAGINATION_KEY, DASHBOARD_LABEL, ROUTE_LINK_LOCATION, MODAL_CUSTOM_MESSAGE } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import DetailsViewManageUser from "./DetailsView/DetailsViewManageUser";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";

class ManageUser extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            viewDetailPage: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            displaySearch: false,
            headerTitle: "manage_user",
            showCreateNewConfirmationModal: false,
            detailsView: false,
            employeeId: 0,
            userId: 0,
        }
    }

    componentDidMount() {
        this.props.getManageUser();
        this.changeHeaderTitle();
        this.setState({
            employeeId: this.props.employeeId != undefined ? this.props.employeeId : 0,
            userId: this.props.userId != undefined ? this.props.userId : 0,

        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.detailsView !== prevState.detailsView) {
            if (!this.state.detailsView) {
                this.props.getManageUser();
            }
            this.changeHeaderTitle();
        }
    }

    componentWillUnmount(){
        this.props.getManageUser(0, true)
    }
    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch})
    }

    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
        })
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                detailsView: true,
                showCreateNewConfirmationModal: false,
                headerTitle: "manage_user_details",
            });
        } else {
            this.setState({ showCreateNewConfirmationModal: false })
        }

    }
    resizePage = (value) => {
        const { getManageUser, resizeManageUserPage } = this.props;
        resizeManageUserPage(value);
        getManageUser();
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractAllUser();
        }
    };
    applyFilter = (isApply) => {
        const { getManageUser, applyManageUserFilter } = this.props;
        applyManageUserFilter(isApply);
        getManageUser();
    }
    handleRowClick = (data) => {
        this.setState({
            detailsView: true,
            employeeId: data.EmployeeId,
            userId: data.UserId
        });
    }
    handleCloseForm = () =>{
        this.setState({
            detailsView: false,
            employeeId: 0,
            userId: 0
        });
    }
    changeHeaderTitle = () => {
        if(this.state.detailsView) {
            this.setState({headerTitle:"manage_user_details"})
        } else {
            this.setState({headerTitle:"manage_user"})
        }
    }

    setEmployeeId = (id) => {
        this.setState({
            employeeId: id
        })
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    render() {
        const { manageUser, getManageUser, setManageUserColSearchStr, sortManageUserList, saveManageUserCustomCols, addManageUserFilter, removeManageUserFilter } = this.props;
        const { Selected, Available, Default } = this.props.manageUser.manageUserList.Columns;
       
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRW])

        return(
            <div className="invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={this.state.showCreateNewConfirmationModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_hr_user}
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />    
                <RequestHeaders headerTitle={this.state.headerTitle} />                
                <div className="request-table data-table fit-width">
                    {this.state.detailsView ? (
                        <DetailsViewManageUser
                            employeeId={this.state.employeeId}
                            userId={this.state.userId}
                            pageRedirection={this.props.detailsView}
                            closeFormAction={this.handleCloseForm}
                            history={this.props.history}
                            setEmployeeId={this.setEmployeeId}
                        />
                    ) :
                    (
                    <DetailsDashboard 
                        // Filter Properties
                        data={manageUser.manageUserList.TableFilterData} 
                        translation={""} 
                        addAction={addManageUserFilter} 
                        removeAction={removeManageUserFilter} 
                        applyAction={this.applyFilter}

                        //CreateNew Action
                        createNewAction={this.handleCreateNewAction}

                        //View Search Textbox
                        viewSearchAction={this.displaySearchBox}

                        //Customize Column
                        firstList={Available} 
                        secondList={Selected} 
                        defaultList={Default} 
                        saveAction={saveManageUserCustomCols}

                        //Extract Button
                        extractAction={(e) => this.onClickExtract(e)}

                         //Access Type
                         isReadOnly={isReadOnly}
                         isReadAndExtractOnly={isReadAndExtractOnly}
                         isReadAndWrite={isReadAndWrite}
                    >
                  {this.props.manageUser.isManageUserLoaded ?
                       <TablePagination  
                        key={TABLE_PAGINATION_KEY.manageUser}
                        classNameWrapper="overflow-auto"
                        columns={manageUser.manageUserList.Headers}
                        pageList={manageUser.manageUserList.Data}
                        pages={manageUser.manageUserList.Pagination}
                        rowClickAction={(item) => {this.handleRowClick(item)}}
                        paginationAction={getManageUser}
                        onColumnClick={sortManageUserList}
                        onColumnSearch={() => { getManageUser(0) }}
                        onColumnSearchChange={setManageUserColSearchStr}
                        isColSearchShow={this.state.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={manageUser.manageUserList.Pagination.TotalEntries}
                        hideStatusIcon={true}
                        />
                    : this.loading()}
                    </DetailsDashboard>
                    )
                  }

                </div>                
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const { manageUser } = state;

        return {
            manageUser
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, manageUserActions),
        dispatch
    )
)(ManageUser));